module.exports = __webpack_public_path__ + "static/android-ios-71455bde24724a95e32eda03927bd4f1.jpg";